import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as AppState from '../../../state/app.state';
import { LobbyWrapUpState } from './lobby-wrap-up.reducer';
import { LobbyServiceCheckList } from '../../shared/models/lobby-service-checklist';
import { LobbyServiceWithCategory } from '../../shared/models/lobby-service';

interface ServiceDetail {
    id: number,
    name: string,
    sortOrder: number | null,
    duration: number,
    isChecked: boolean,
    isCheckListAvailable: boolean,
    checkListItems: LobbyServiceCheckList[]
}

export interface State extends AppState.State {
    lobbyWrapUp: LobbyWrapUpState;
}

const getWrapUpFeatureState = createFeatureSelector<LobbyWrapUpState>('lobbyWrapUp');

export const getShowWrapUpPopUp = createSelector(
    getWrapUpFeatureState,
    state => {
        return {
            openWrapUpPopUp: state.openWrapUpPopUp,
            showWrapUpButton: state.showWrapUpButton
        };
    }
);

export const getLobbyEntryDetail = createSelector(
    getWrapUpFeatureState,
    state => state.lobbyEntryDetail
);
export const getCurrentInteractionServiceProvided = createSelector(
    getWrapUpFeatureState,
    state => state.currentInteractionProvidedServices
);


export const getServiceFilterValue = createSelector(
    getWrapUpFeatureState,
    state => state.serviceFilter
);

export const getIsImpersonateAssist = createSelector(
    getWrapUpFeatureState,
    state => state.isImpersonateAssist
);

export const getImpersonatedByName = createSelector(
    getWrapUpFeatureState,
    state => state.impersonatedByName
);

export const getImpersonatedByCode = createSelector(
    getWrapUpFeatureState,
    state => state.impersonatedByCode
);

export const getWrapUpCommenr = createSelector(
    getWrapUpFeatureState,
    state => state.wrapUpComment
);

export const getShowCheckListPopUp = createSelector(
    getWrapUpFeatureState,
    state => {
        let serviceDetail: ServiceDetail = {
            id: 0,
            name: '',
            sortOrder: null,
            duration: 0,
            isChecked: false,
            isCheckListAvailable: false,                                    
            checkListItems: []
        };

        if (state.checkListItems.length > 0) {
            const service = state.lobbyServices.find(s => s.service.id === state.checkListItems[0].serviceId)?.service;
            
            if (service != null) {
                serviceDetail = {
                    ...service,
                    checkListItems: state.checkListItems
                };
            } else throw new Error(`[lobby/lobby-wrap-up/state/index.ts]: Unexpected code path, "service" was undefined.`)
        }

        return {
            showCheckList: state.showCheckListPopUp,
            showRequestedServiceCheckList: state.showRequestedServiceCheckListPopUp,
            serviceDetail: serviceDetail
        };
    }
);

export const getShowCheckListPopUpForRequestedServices = createSelector(
    getWrapUpFeatureState,
    state => {
        let serviceDetails: any[] = [];

        if (state.checkListItemsForRequestedService.length > 0) {
            const checkListAvailableServices = state.checkListItemsForRequestedService.map(c => c.serviceId);
            serviceDetails = state.lobbyServices.filter(s => checkListAvailableServices.indexOf(s.service.id) > -1).map(ls => ({
                ...ls.service,
                checkListItems: state.checkListItemsForRequestedService.filter(ci => ci.serviceId === ls.service.id)
              }));
        }
        return {
            showCheckList: state.showCheckListPopUp,
            showRequestedServiceCheckList: state.showRequestedServiceCheckListPopUp,
            serviceDetails: serviceDetails
        };
    }
);

export const getServices  = (showCategoriesInLobby: boolean) =>  createSelector(
    getWrapUpFeatureState,
    getServiceFilterValue,
    (state, filterValue) => {
        const services = Object.assign<LobbyServiceWithCategory[], LobbyServiceWithCategory[]>([], state.lobbyServices);
        if (filterValue !== '') {
            if (showCategoriesInLobby) {
                return services.filter(s => s.service.name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()))
                            .sort((a, b) => (a.categorySortOrder > b.categorySortOrder) ? 1 : (a.categorySortOrder === b.categorySortOrder) ? ((a.service.sortOrder! > b.service.sortOrder!) ? 1 : -1) : -1 )
                            .reduce((r, a) => {
                                r[a.categoryName] = r[a.categoryName] || [];
                                r[a.categoryName].push(a);
                                return r;
                }, Object.create(null));
            } else {
                return services.filter(s => s.service.name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()))
                                          .sort((a, b) => (a.service.sortOrder! > b.service.sortOrder!) ? 1 : -1);
            }
        } else {
            if (showCategoriesInLobby) {
                return services.sort((a, b) => (a.categorySortOrder > b.categorySortOrder) ? 1 : (a.categorySortOrder === b.categorySortOrder) ? ((a.service.sortOrder! > b.service.sortOrder!) ? 1 : -1) : -1 )
                                          .reduce((r, a) => {
                                            r[a.categoryName] = r[a.categoryName] || [];
                                            r[a.categoryName].push(a);
                                            return r;
                                          }, Object.create(null));
            } else {
                return services.sort((a, b) => (a.service.sortOrder! > b.service.sortOrder!) ? 1 : -1);
            }
        }
    }
);
